import React, { useEffect } from "react";
import ProductDetailLeftContent from "./ProductDetailLeftContent/ProductDetailLeftContent";
import ProductDetailRightContent from "./ProductDetailRightContent/ProductDetailRightContent";
import SystemAlerts from "../../component/SystemAlerts";
import { useProductStore } from "src/hooks/product";
import liveAuth from "src/helper/liveAuth";
import ProductDetailAPICall from "src/service/ProductDetailAPICall";
import ProductDetail from "src/model/ProductDetail";
import AxiosIndicatorRunTimeLoader from "src/component/AxiosIndicatorRunTimeLoader";
import { __set } from "src/store/axios_indicator";
import Helper from "src/support/Helper";
import System from "src/helper/system";

import useReduxState from "src/hooks/useReduxState";
import { useAlertStore } from "src/hooks/Alert";
import { useProductInventoryStore } from "src/hooks/productInventory";
import Constants from "src/support/Constants";

const ProductDetailContent = (props) => {
  const [{ productDetail }, { }, { }] = useProductStore();
  const url = window.location.href?.split('?')[0];
  const urlAry = url?.split('/').filter(data => data.length > 0);
  const { speedBoats: { silicaAbbr, abacusAbbr } } = Constants;
  const ItemNumber = (System.avUserInfoData.speedBoatAbbr === silicaAbbr || System.avUserInfoData.speedBoatAbbr === abacusAbbr) ? Helper.toCapitalize(urlAry[urlAry.length - 1]) : Helper.toUpperCase(urlAry[urlAry.length - 1]);
  const [, setStockAlertState] = useReduxState({}, "setStockAlertState");
  const [, { get_stock_alerts_products }] = useAlertStore();
  const [{ inventoryList }, { get_inventory_by_id }] = useProductInventoryStore();
  const userType = System.avUserInfoData.userType
  const { siteUser: { CORE } } = Constants;

  useEffect(() => {
    async function fetchHere() {
      await fetchProductDetailFromServer();
    }

    fetchHere();
  }, []);

  useEffect(() => {
    if(productDetail?.value && userType === CORE){
      if (get_inventory_by_id(productDetail?.value?.ERPPartNumber).qas === 0){
        fetch_stock_alert_products_details()
      }
    }
  }, [inventoryList])

  const fetch_stock_alert_products_details = async () => {
    const params = [{
      itemNumber: productDetail?.value?.ItemNumber,
      erpPartNumber: productDetail?.value?.ERPPartNumber,
      erpMfrPartNumber: productDetail?.value?.ERPMFRPartNumber,
      customerPartNumber: productDetail?.value?.CustomerPartNumbers?.length > 0
          ? productDetail?.value?.CustomerPartNumbers?.[0]?.CPN : ""
    }];

    let res = await get_stock_alerts_products(params);

    if (res?.data) {
      const stockAlertList = res?.data?.stockAlertPartDetails.reduce((acc, item) => {
        acc[item.itemNumber] = item;
        return acc;
      }, {});
      setStockAlertState(stockAlertList)
    } else {
      setStockAlertState({})
    }
  };


  const fetchProductDetailFromServer = async () => {
    __set('PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING')
    let res_detected_from_ERPPartNumber = false;
    if (ItemNumber && res_detected_from_ERPPartNumber === false) {
      let itemNumber = ItemNumber;
      if (ItemNumber.slice(-1) === "/") {
        itemNumber = ItemNumber.slice(0, -1);
      }
      new ProductDetail().setProductDetail(
        await new ProductDetailAPICall().getProductDetailByItemNumber(
          Helper.capitalizeFirstLetter(itemNumber), true, true)
      );
    }
  };

  const RequestUserSignIn = () => {
    return (
      <div>
        <div className="container text-center mt-5 mb-5 access-denied">
          <h1 className="font-oswald font-light text-green">
            We're Sorry! You do not have access to this content.
          </h1>
          <hr />
          <p>
            You've reached a page that requires Sign In. If you are signed in
            and don't have <br /> permission to view the page contact{" "}
            <a href="mailto:onlinesupporteu@avnet.com" className="text-blue">
              online support.
            </a>
          </p>
        </div>
      </div>
    );
  };

  //   /*
  //     if user is logged in then PDP page should be accessed.
  //     if user is not logged in and Product webcode is 1, then also PDP page should be accessed.
  //     in all other cases, the PDP page should not be accessed.
  //   */

  return (
    <>
      {productDetail?.value == undefined ? (
        <>
          <AxiosIndicatorRunTimeLoader overlay={true} />
        </>
      ) : (
        <>
          {!liveAuth.check() ? (
            <>
              {productDetail?.value?.ERPPartNumber ? (
                <div className="content-area compare-open">
                  <SystemAlerts />
                  {parseInt(productDetail?.value?.WebCode) > 1 ? (
                    <RequestUserSignIn />
                  ) : (
                    <div className="container pdp-container">
                      <div className="bs5 row">
                        <div className="col-xl-8 col-lg-7 pdp-container-left">
                          <ProductDetailLeftContent fetch_stock_alert_products_details={fetch_stock_alert_products_details}/>
                        </div>
                        <ProductDetailRightContent fetch_stock_alert_products_details={fetch_stock_alert_products_details}/>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  {productDetail?.value == undefined ? (
                    <></>
                  ) : (
                    <RequestUserSignIn />
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {productDetail?.value?.ERPPartNumber ? (
                <>
                  <SystemAlerts />
                  <div className="container pdp-container">
                    <div className="bs5 row pdp-row">
                      <div className="col-xl-8 col-lg-7 pdp-container-left">
                        <ProductDetailLeftContent fetch_stock_alert_products_details={fetch_stock_alert_products_details}/>
                      </div>
                      <ProductDetailRightContent fetch_stock_alert_products_details={fetch_stock_alert_products_details}/>
                    </div>
                  </div>
                </>
              ) : (
                <RequestUserSignIn />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default ProductDetailContent;
